<template>
  <div
    :class="$style.root"
  >
    <i18nLink
      :class="$style.item"
      :to="{
        name: 'program-slug',
        params: {
          slug: slug
        }
      }"
    >
      <div
        v-if="status !== 'unknown'"
        :class="$style.status"
      >
        <div v-if="tag" :class="$style.tag">{{ tag }}</div>
        <LayoutHorizontalLineComponent />
      </div>

      <div :class="$style.title">
        {{ title }}
      </div>

      <div :class="$style.details">
        <div :class="$style.info">
          <div>
            <div v-if="status" :class="$style.tag">{{ status }}</div>
            <CoreDateTimeRangeComponent
              :class="$style.dateTimeRange"
              v-for="range in localizedData?.date_time_ranges"
              :key="range?.id"
              :dateStart="range?.date_time_start"
              :dateEnd="range?.date_time_end"
            />
          </div>

          <div
            v-if="localizedData?.opening_date_time?.date_time_start && localizedData?.opening_date_time?.date_time_end"
          >
            <div :class="$style.tag">{{ $t('program.openingEvent') }}</div>
            <CoreDateTimeRangeComponent
              :class="$style.dateTimeRange"
              :key="localizedData?.opening_date_time?.id"
              :dateStart="localizedData?.opening_date_time?.date_time_start"
              :dateEnd="localizedData?.opening_date_time?.date_time_end"
            />
          </div>
        </div>

        <CoreImageComponent
          v-if="localizedData?.cover_image?.data?.attributes"
          :image="localizedData?.cover_image?.data?.attributes"
          :class="$style.image"
        />

        <CoreTextComponent
          v-if="introduction"
          :class="$style.introduction"
          :string="introduction"
        />
      </div>
    </i18nLink>

    <SharedThumbnailProgramDefaultRelatedComponent
      v-if="data?.attributes?.program_entries?.data?.length && includeRelated"
      :entries="data?.attributes?.program_entries?.data"
      :title="title"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  data: Object,
  includeRelated: {
    type: Boolean,
    default: true
  }
})

const localizedData = computed(() => {
    return i18nGetLocalizedData(baseStrapiGetAttributes(props?.data))
})

const title = computed(() => {
  return localizedData?.value?.titles?.current_locale || localizedData?.value?.titles?.i18n_title_en
})

const slug = computed(() => {
  return localizedData?.value?.slugs?.current_locale || localizedData?.value?.slugs?.i18n_slug_en
})

const status = props?.forcePastStatus ? 'past' : getItemProgramStatus(props?.data)

const introduction = computed(() => {
  return baseTruncateString(localizedData?.value?.introductions?.current_locale || localizedData?.value?.introductions?.i18n_richtext_en, 20)
})

const tag = computed(() => {
  return localizedData?.value?.tags?.current_locale || localizedData?.value?.tags?.i18n_text_en
})
</script>

<style module lang="scss">
.root {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.item:hover  {
  color: var(--color--accent);
}

.status {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--unit--spacer);

  max-width: var(--container--default--without-padding);

  margin-left: auto;
  margin-right: auto;
  margin-bottom: calc(var(--unit--spacer) * 2);

  text-transform: uppercase;

  width: 30vw;

  @media (max-width: $breakpoint-l) {
    width: 50vw;
  }

  @media (max-width: $breakpoint-m) {
    width: 100%;
  }
}

.title {
  composes: font-size-large from global;
  margin-bottom: var(--unit--spacer);
  text-align: center;
}

.details {
  display: grid;
  grid-template-areas: 'dateTimeRange  image introduction';
  grid-template-columns: 1fr 30vw 1fr;
  grid-column-gap: var(--unit--horizontal);
  grid-row-gap: var(--unit--spacer);
  align-items: end;

  width: 100%;

  @media (max-width: $breakpoint-l) {
    grid-template-columns: 1fr 50vw 1fr;
  }

  @media (max-width: $breakpoint-m) {
    align-items: start;

    grid-template-areas:
        'image image'
        'dateTimeRange introduction';
    grid-template-columns: .5fr 1fr;
  }

  @media (max-width: $breakpoint-s) {
    align-items: start;

    grid-template-areas:
        'image'
        'dateTimeRange'
        'introduction';
    grid-template-columns: 1fr;
  }
}

.details .dateTimeRange {
  display: block;
}

.details .dateTimeRange time {
}

.details .tag {
  text-transform: uppercase;
  word-break: break-all;
}

.details .info {
  display: flex;
  flex-direction: column;
  gap: var(--unit--vertical);

  text-align: right;

  @media (max-width: $breakpoint-s) {
    text-align: left;
  }
}

.details .image {
  grid-area: image;
}

.details .dateTimeRange {
  grid-area: dateTimeRange;
  text-align: right;

  @media (max-width: $breakpoint-s) {
    text-align: left;
  }
}

.details .introduction {
  @media (max-width: $breakpoint-l) {
    grid-area: introduction;
  }

  @media (max-width: $breakpoint-s) {
    text-align: left;
  }
}
</style>
